import {ListViewProvider} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {KTCard} from '../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../_metronic/layout/core'
import { BlockTable } from './table/BlockTable'

// const breadcrumbs: Array<PageLink> = [
//   {
//     title: 'Home',
//     path: '/dashboard',
//     isSeparator: false,
//     isActive: false,
//   },
//   {
//     title: '',
//     path: '',
//     isSeparator: true,
//     isActive: false,
//   },
// ]

const BlockList = () => {
  return (
    <KTCard>
      <BlockTable />
    </KTCard>
  )
}

const BlockListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>

        {/* ✅ Page title MUST be here */}
        <PageTitle>Block User list</PageTitle>

        {/* ✅ Page content */}
        <BlockList />

      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {BlockListWrapper}
